import React from "react";
import {Container} from "../styles/Styles";
import {useAuth} from "../context/AuthContext";
import {Roles} from "../components/common/roles";
import {Navigate} from "react-router-dom";
import {ToastContainer} from "react-toastify";

const Dashboard = () => {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/" />;
    }

    if (user?.role[0] === Roles.ADMIN) {
        return <Navigate to="/admin" />;
    }

    if (user?.role[0] === Roles.GUIDE) {
        return <Navigate to="/guide" />;
    }

    if (user?.role[0] === Roles.COORDINATOR) {
        return <Navigate to="/coordinator" />;
    }

    return (
        <Container>
            <div className="user-dashboard">
                <h1>Welcome, {user?.email}</h1>
                <p>Your role: {user?.role.join(", ")}</p>
            </div>
            <ToastContainer position="bottom-right" autoClose={5000} />
        </Container>
    );
}

export default Dashboard;
